import React, { Component } from "react";
import { dateConvert } from "../../common/Helpers";
import { Localization } from "../../common/Localization";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Renderers } from "../../common/GridRowRenderer";
import { Button } from "@progress/kendo-react-buttons";
import Moment from "moment";
import DetailDodavkyDialogContent from "../../dialogs/DetailDodavkyDialogContent";
import { homeController } from "../../../controllers/home.controller";
import DialogWindow from "../../common/DialogWindow";
import KeyboardEventHandler from "react-keyboard-event-handler";
import NasnimanyCiarovyKod from "../../common/SnimanieCiarovehoKodu/NasnimanyCiarovyKod";
import CheckBalikFromCiarovyKod from "../../common/SnimanieCiarovehoKodu/CheckBalikFromCiarovyKod";
import { MessageTypeEnum, CiarovyKodAllowedHandleKeys, ValueTypeEnum, ButtonMessageEnum, RoleNames, LogLevel } from "../../../enums";
import PrijemBalikaDialogContent from "../../dialogs/PrijemBalikaDialogContent";
import RucniNahlDodavkyDialogContent from "../../dialogs/RucniNahlDodavkyDialogContent";
import { Zvuky } from "../../common/Zvuky";
import confirmService from "../../common/confirmService";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import promptService from "../../common/promptService";
import { authenticationService } from "../../../services/authentication.service";
import { prijemBalikaController } from "../../../controllers/prijembalika.controller";
import PotvrditPrijemDodavkyDialogContent from "../../dialogs/PrijomDodavok/PotvrditPrijemDodavkyDialogContent";
import NahlasenieKusyDialogContent from "../../dialogs/RucniNahlasenieDodavky/NahlasenieKusyDialogContent";
import { logController } from "../../../controllers/log.controller";

class NahlasenieNenahlaseneDodavky extends Component {
    state = {
        items: [],
        selectedDodavka: null,
        selectedIdDodavka: null,
        loading: true,
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        },
        confirmDialog: {
            show: false
        }
    };

    componentDidMount() {
        this.reloadGrid();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.shouldReloadGrid && this.props.shouldReloadGrid !== nextProps.shouldReloadGrid) {
            this.reloadGrid();
        }
        return true;
    }

    reloadGrid = () => {
        this.setState({ selectedIdDodavka: null, selectedDodavka: null, loading: true });
        homeController
            .getNahlasenieNenahlaseneDodavky()
            .then((ajaxData) => {
                let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
                if (!data.isError) {
                    this.setState({ items: data, loading: false });
                    this.props.afterReload();
                } else {
                    logController.logMessage("NahlasenieNenahlaseneDodavky.reloadGrid: " + data.errorMessage, LogLevel.Error);
                    this.setState({
                        errorMessage:
                            "Server vrátil chybu pri načítaní zoznamu. Chyba bola zaznamenaná do logu.\n\nSkúste prosím načítať zoznam znova pomocou tlačidla Aktualizovať.",
                        loading: false
                    });
                }
            })
            .catch((error) => {
                logController.logMessage("NahlasenieNenahlaseneDodavky.reloadGrid: " + error, LogLevel.Error);
                this.setState({
                    errorMessage:
                        "Server vrátil chybu pri načítaní zoznamu. Chyba bola zaznamenaná do logu.\n\nSkúste prosím načítať zoznam znova pomocou tlačidla Aktualizovať.",
                    loading: false
                });
            });
    };

    changeTitle = (title) => {
        var dialogProperty = { ...this.state.dialog };
        dialogProperty.title = title;
        this.setState({ dialog: dialogProperty });
    };

    gridRowEventHandler = (eventType, dataItem) => {
        var localizationService = provideLocalizationService(this);
        if (eventType === "onDoubleClick") {
            this.setState({
                dialog: {
                    title: localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Dodávka", "Dodávka"),
                    content: () => (
                        <DetailDodavkyDialogContent
                            selectedDodavkaId={dataItem.iddodavka}
                            changeTitle={this.changeTitle}
                            zruseniEnabled={true}
                            reloadGrid={this.reloadGrid}
                        />
                    ),
                    height: "90%",
                    width: "90%"
                }
            });
        }
    };

    openPrijemBalikaDialog(zadanyKod) {
        var localizationService = provideLocalizationService(this);
        this.props.switchKeyboardEventHandler(true);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("PríjemBalíka.Príjem tovaru", "Príjem tovaru"),
                hasClosingConfirmDialog: true,
                content: (onClose, showClosingConfirmDialog, allowOpeningConfirmDialog, toggleErrorDialog, closeConfirmDialog) => (
                    <PrijemBalikaDialogContent
                        zadanyKod={zadanyKod}
                        toggleDialog={onClose}
                        reloadSpravyGrid={this.props.reloadSpravyGrid}
                        showClosingConfirmDialog={showClosingConfirmDialog}
                        balikIsChanged={allowOpeningConfirmDialog}
                        showErrorDialog={toggleErrorDialog}
                        closeConfirmDialog={closeConfirmDialog}
                        switchKeyboardEventHandler={this.props.switchKeyboardEventHandler}
                        changeTitle={this.changeTitle}
                        reloadNahlasNenahlasDodavkyGrid={this.reloadGrid}
                        openDialogNahlaseniKusy={this.openDialogNahlaseniKusy}
                    />
                ),
                height: "90%",
                width: "822px",
                extraClosingCallback: () => {
                    this.props.switchKeyboardEventHandler(false);
                }
            }
        });
    }

    openDialogNahlaseniKusy = (dodavka) => {
        var localizationService = provideLocalizationService(this);
        var title = localizationService
            .toLanguageString("RucniNahl.Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>", "Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>")
            .replace("<P1>", dodavka.cisloDodavky || "")
            .replace("<P2>", dodavka.odosilatel || "")
            .replace("<P3>", Moment(dodavka.datumExpedicie).format("D.M.YYYY") || "");

        this.setState({
            dialog: {
                title: title,
                hasClosingConfirmDialog: true,
                content: (onClose) => (
                    <NahlasenieKusyDialogContent
                        toggleDialog={onClose}
                        dodavka={dodavka}
                        reloadSpravyGrid={this.props.reloadSpravyGrid}
                        reloadNahlasNenahlasDodavkyGrid={this.reloadGrid}
                    />
                ),
                height: "600px",
                width: "1000px"
            }
        });
    };

    handleKeyEvent(key, e) {
        this.setState({
            keyboardEvent: e
        });
        e.preventDefault();
        return false;
    }

    async handleTestKeyEvent(key, e) {
        var localizationService = provideLocalizationService(this);
        switch (key) {
            case "shift+b":
                // B - zadání pořadového čísla balíka
                if (authenticationService.hasCurrentUserRole(RoleNames.Administrator)) {
                    if (!this.state.selectedIdDodavka) {
                        await confirmService.show({
                            type: MessageTypeEnum.EXCLAMATION,
                            message: localizationService.toLanguageString(
                                "PríjemDod.Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !",
                                "Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !"
                            )
                        });
                        return;
                    }

                    prijemBalikaController.TEMP_GetPocetBaliku(this.state.selectedIdDodavka).then(async (response) => {
                        if (response.isError) {
                            Zvuky.playChyba();
                            await confirmService.show({
                                message: response.errorMessage,
                                logMessage: true
                            });
                            return;
                        }

                        this.props.switchKeyboardEventHandler(true);
                        const promptResult = await promptService.show({
                            title: "Poradové číslo balíka",
                            message: "Poradové číslo balíka (1-" + response.pocetBaliku + ")",
                            valueType: ValueTypeEnum.NUMBER,
                            logMessage: true
                        });
                        this.props.switchKeyboardEventHandler(false);
                        if (promptResult.button != ButtonMessageEnum.OK) {
                            this.props.switchKeyboardEventHandler(false);
                            return;
                        }

                        if (promptResult.value.length <= 6) {
                            if (promptResult.value < 1 || promptResult.value > response.pocetBaliku) {
                                await confirmService.show({
                                    message: "Neplatné zadané poradové číslo balíka !",
                                    logMessage: true
                                });
                                return;
                            }
                        }

                        prijemBalikaController.TEMP_GetKodBalika(this.state.selectedIdDodavka, promptResult.value).then(async (response) => {
                            if (response.isError) {
                                Zvuky.playChyba();
                                await confirmService.show({
                                    message: response.errorMessage,
                                    logMessage: true
                                });
                                return;
                            }

                            this.openPrijemBalikaDialog(response.zadanyKod);
                        });
                    });
                }
                break;
        }
        e.preventDefault();
        return false;
    }

    CheckNewBalik = async (response) => {
        if (response.isError) {
            Zvuky.playChyba();
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: response.errorMessage
            });
            return;
        }
        this.openPrijemBalikaDialog(response.zadanyKod);
    };

    nahlasit = () => {
        var localizationService = provideLocalizationService(this);
        this.props.switchKeyboardEventHandler(true);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("TODO", "Nenahlášené dodávky zboží"), //TODO
                hasClosingConfirmDialog: true,
                content: (onClose, closeConfirmDialog) => (
                    <RucniNahlDodavkyDialogContent
                        toggleDialog={onClose}
                        reloadGrid={this.reloadHomePageGrids}
                        reloadSpravyGrid={this.props.reloadSpravyGrid}
                        closeConfirmDialog={closeConfirmDialog}
                        reloadNahlasNenahlasDodavkyGrid={this.reloadGrid}
                    />
                ),
                height: "420px",
                width: "862px",
                extraClosingCallback: () => {
                    this.props.switchKeyboardEventHandler(false);
                }
            }
        });
    };

    balikBezKodu = async () => {
        var localizationService = provideLocalizationService(this);

        this.props.switchKeyboardEventHandler(true);
        const promptResult = await promptService.show({
            title: localizationService.toLanguageString(
                "MenuFRM.Balík/Lot bez kódu alebo s nečitateľným kódom",
                "Balík/Lot bez kódu alebo s nečitateľným kódom"
            ),
            message: localizationService.toLanguageString("MenuFRM.Kód balíka/lotu:", "Kód balíka/lotu:"),
            valueType: ValueTypeEnum.NUMBER,
            logMessage: true
        });
        if (promptResult.button != ButtonMessageEnum.OK) {
            this.props.switchKeyboardEventHandler(false);
            return;
        }

        this.openPrijemBalikaDialog(promptResult.value);
    };

    prijatKusy = async () => {
        var localizationService = provideLocalizationService(this);

        if (!this.state.selectedIdDodavka || !this.state.selectedDodavka) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString(
                    "PríjemDod.Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !",
                    "Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !"
                )
            });
            return;
        }

        var dodavka = this.state.selectedDodavka;
        if (!(dodavka.skladFrom == 91 || (dodavka.skladFrom == 1 && dodavka.cisloDodavky >= 20000 && dodavka.cisloDodavky <= 39999))) {
            await confirmService.show({
                type: MessageTypeEnum.CRITICAL,
                message: "Tento typ dodávky nemôže obsahovať manipulačné jednotky kusy !"
            });
            return;
        }

        this.openPrijemBalikaDialog("KUSY" + this.state.selectedIdDodavka);
    };

    potvrditPrijemDodavky = () => {
        var localizationService = provideLocalizationService(this);
        this.props.switchKeyboardEventHandler(true);
        this.setState({
            dialog: {
                title: localizationService.toLanguageString("PríjemDod_Potvr.Potvrdiť príjem dodávky", "Potvrdiť príjem dodávky"),
                content: (onClose) => (
                    <PotvrditPrijemDodavkyDialogContent
                        toggleDialog={onClose}
                        reloadSpravyGrid={this.props.reloadSpravyGrid}
                        reloadNahlasNenahlasDodavkyGrid={this.reloadGrid}
                    />
                ),
                extraClosingCallback: () => {
                    this.props.switchKeyboardEventHandler(false);
                },
                height: "488px",
                width: "862px"
            }
        });
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);
        var renderers = new Renderers();

        return (
            <div id="NahlasenieNenahlaseneDodavky">
                <KeyboardEventHandler
                    handleKeys={CiarovyKodAllowedHandleKeys}
                    onKeyEvent={(key, e) => this.handleKeyEvent(key, e)}
                    // isExclusive={true}
                    handleFocusableElements={true}
                    isDisabled={this.props.keyboardEventHandlerDisabled}
                />
                <NasnimanyCiarovyKod keyboardEvent={this.state.keyboardEvent}>
                    <CheckBalikFromCiarovyKod getResponse={this.CheckNewBalik} />
                </NasnimanyCiarovyKod>
                <KeyboardEventHandler
                    handleKeys={["shift+b"]}
                    onKeyEvent={(key, e) => this.handleTestKeyEvent(key, e)}
                    handleFocusableElements={true}
                    isDisabled={this.props.keyboardEventHandlerDisabled}
                />
                <h2>
                    <Localization messageKey={"MenuFRM.NENAHLÁSENÉ DODÁVKY"} defaultMessage={"NENAHLÁSENÉ DODÁVKY"} /> ({items.length})
                </h2>
                <div onMouseDown={(e) => e.preventDefault() /* prevents browser text selection */}>
                    <Grid
                        data={items.map((item) => ({ ...item, selected: item.iddodavka === this.state.selectedIdDodavka }))}
                        selectedField="selected"
                        onRowClick={(e) => {
                            this.setState({ selectedIdDodavka: e.dataItem.iddodavka, selectedDodavka: e.dataItem });
                        }}
                        rowRender={(trElement, dataItem) => renderers.rowRender(trElement, dataItem, this.gridRowEventHandler)}>
                        <GridColumn
                            field="datum"
                            title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Expedované", "Expedované")}
                            format="{0:d.M.yyyy}"
                            width="80px"
                        />
                        <GridColumn
                            field="skladNazov"
                            title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Odosielateľ", "Odosielateľ")}
                        />
                        <GridColumn
                            field="cisloDodavky"
                            title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Dodávka", "Dodávka")}
                            width="70px"
                        />
                        <GridColumn
                            field="sposobDopravy"
                            title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Doprava", "Doprava")}
                        />
                        <GridColumn
                            field="pocetBalikov"
                            title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Balíkov-Lotov-Kusov", "Balíkov-Lotov-Kusov")}
                        />
                        <GridColumn
                            field="pocetKusov"
                            title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Kusov", "Kusov")}
                            width="50px"
                        />
                    </Grid>
                </div>
                <div className="grid-button-bar">
                    <div className="col-sm-6">
                        <Button onClick={this.balikBezKodu}>
                            <Localization messageKey={"MenuFRM.Balík/Lot bez kódu"} defaultMessage={"Balík/Lot bez kódu"} />
                        </Button>{" "}
                        <Button onClick={this.prijatKusy}>
                            <Localization messageKey={"MenuFRM.Prijať kusy"} defaultMessage={"Prijať kusy"} />
                        </Button>
                    </div>
                    <div className="col-sm-6 text-right">
                        <Button onClick={this.potvrditPrijemDodavky} className="text-danger">
                            <Localization messageKey={"MenuFRM.Potvrdiť príjem dodávky"} defaultMessage={"Potvrdiť príjem dodávky"} />
                        </Button>{" "}
                        <Button onClick={this.nahlasit} className="font-bold">
                            <Localization messageKey={"MenuFRM.Nahlásit"} defaultMessage={"Nahlásit"} />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    renderError(errorMessage) {
        return (
            <div id="NahlasenieNenahlaseneDodavky">
                <h2>
                    <Localization messageKey={"MenuFRM.NENAHLÁSENÉ DODÁVKY"} defaultMessage={"NENAHLÁSENÉ DODÁVKY"} />
                </h2>
                <div className="alert alert-danger">{errorMessage}</div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : this.state.errorMessage ? (
            this.renderError(this.state.errorMessage)
        ) : (
            this.renderTable(this.state.items)
        );

        return (
            <div>
                {contents}
                <DialogWindow dialog={this.state.dialog} />
                {this.state.confirmDialog.show && this.state.confirmDialog.content}
            </div>
        );
    }
}

export default NahlasenieNenahlaseneDodavky;

registerForLocalization(NahlasenieNenahlaseneDodavky);



// WEBPACK FOOTER //
// ./src/components/views/Home/NahlasenieNenahlaseneDodavky.js